<template>
  <div class="tabsPlatform-content margin-general var-table">
    <SelectCustom class="selectItem" :options="tabs" v-model="selected" />

    <div class="buttonsContainer" ref="buttonsContainer" role="tablist">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        :id="`conditions-tab-${tab.value}`"
        type="button"
        class="buttonItem"
        :class="{ selected: selected === tab.value }"
        role="tab"
        :tabindex="selected === tab.value ? 0 : -1"
        :aria-selected="selected === tab.value"
        :aria-controls="`conditions-panel-${tab.value}`"
        @click="selectTab(tab.value)"
        @keydown.left.prevent="moveTab(-1)"
        @keydown.right.prevent="moveTab(1)"
        @keydown.home.prevent="focusTab(0)"
        @keydown.end.prevent="focusTab(tabs.length - 1)"
      >
        {{ displayText(tab.label) }}
      </button>
      <span class="selected-border" :style="borderStyle">
        <div class="border-style"></div>
      </span>
    </div>

    <div class="card-content">
      <div
        v-for="tab in tabs"
        v-show="selected === tab.value"
        :id="`conditions-panel-${tab.value}`"
        :key="tab.value"
        class="content-table"
        role="tabpanel"
        :aria-labelledby="`conditions-tab-${tab.value}`"
      >
        <div class="flex-table" role="table" :aria-label="displayText(tab.label)">
          <div class="table-header" role="rowgroup">
            <div
              v-for="(item, itemIndex) in categoryFor(tab.value).titleCards"
              :key="itemIndex"
              style="display: flex"
              class="cont-head"
              role="row"
            >
              <div
                v-for="(li, itemIndex1) in item"
                :key="itemIndex1"
                :class="li.class"
                class="flex-cell"
                role="columnheader"
              >
                <span class="body-6-bold">
                  {{ displayText(li.text) }}
                </span>
                <div v-if="li.optionalDiv && li.optionalDiv.length">
                  <span
                    class="body-6-bold"
                    v-for="(optional, optionalIndex) in li.optionalDiv"
                    :key="optionalIndex"
                  >
                    {{ displayText(optional.text) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="table-body" role="rowgroup">
            <div
              v-for="(item, itemIndex) in categoryFor(tab.value).cards"
              v-show="itemIndex < currentPage * itemsPerPage"
              :key="itemIndex"
              class="flex-row"
              role="row"
            >
              <div
                v-for="(li, itemIndex1) in item.items"
                :key="itemIndex1"
                class="flex-cell"
                :class="li.class"
                :role="itemIndex1 === 0 ? 'rowheader' : 'cell'"
              >
                <span class="body-4">
                  {{ displayText(li.column1) }}
                </span>
                <span v-if="li.column2" class="body-4">{{
                  displayText(li.column2)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      v-if="!noMoreElements"
      class="load-more-button"
      @click="loadMore"
      :disabled="currentPage >= totalPages"
      :class="{ 'no-more-elements': noMoreElements }"
    >
      <span class="material-symbols-outlined" translate="no">expand_more</span>
      {{ $t("btn-more.loadMore") }}
    </button>
  </div>
</template>

<script>
import SelectCustom from "../utils/select/SelectCustom.vue";

export default {
  name: "spreadsTable",
  components: {
    SelectCustom,
  },
  props: {
    // Corregido a Array para mayor consistencia
    tabs: {
      type: Array,
      default: () => [],
    },
    categories: Object,
    titleCards: Object,
    cards: Object,
  },
  data() {
    return {
      // Inicializado en null para manejar carga asíncrona
      selected: null,
      selectedButtonIndex: 0,
      borderStyle: {},
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  watch: {
    tabs: {
      handler(newTabs) {
        if (!this.selected && newTabs && newTabs.length > 0) {
          this.selected = newTabs[0].value;
        }
      },
      immediate: true,
    },
    selected(newSelected) {
      this.selectedButtonIndex = this.tabs.findIndex((tab) => tab.value === newSelected);
      this.currentPage = 1;
      this.updateBorderBottomStyle();
    },
  },
  computed: {
    totalItems() {
      return this.categoryFor(this.selected).cards.length;
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    noMoreElements() {
      return this.currentPage >= this.totalPages;
    },
  },
  mounted() {
    this.updateBorderBottomStyle(); // Llamada al iniciar el componente
  },
  methods: {
    categoryFor(tabValue) {
      return this.categories?.[tabValue]?.[0] || { titleCards: {}, cards: [] };
    },
    displayText(text) {
      if (!text) {
        return "";
      }
      // this.$te verifica si la clave de traducción existe
      if (this.$te(text)) {
        return this.$t(text);
      }
      return text;
    },
    selectTab(tabName) {
      if (this.tabs.some((tab) => tab.value === tabName)) {
        this.selected = tabName;
      }
    },
    moveTab(offset) {
      if (!this.tabs.length) return;
      const currentIndex = this.tabs.findIndex((tab) => tab.value === this.selected);
      this.focusTab((currentIndex + offset + this.tabs.length) % this.tabs.length);
    },
    focusTab(index) {
      const tab = this.tabs[index];
      if (!tab) return;
      this.selected = tab.value;
      this.$nextTick(() => {
        const buttons = this.$refs.buttonsContainer?.querySelectorAll('[role="tab"]');
        buttons?.[index]?.focus();
      });
    },
    updateBorderBottomStyle() {
      this.$nextTick(() => {
        if (this.$refs.buttonsContainer) {
          const button = this.$refs.buttonsContainer.children[this.selectedButtonIndex];
          if (button) {
            this.borderStyle = {
              width: `${button.offsetWidth}px`,
              left: `${button.offsetLeft}px`,
            };
          }
        }
      });
    },
    loadMore() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
      }
    },
  },
};
</script>
